var scroller;

document.addEventListener("DOMContentLoaded", (event) => {
  console.clear();
  gsap.registerPlugin(ScrollTrigger, SplitText);

  //NAV SCROLLED
  ScrollTrigger.create({
    start: "20px top",
    onEnter: function () {
      document.body.classList.add("scrolled");
    },
    onLeaveBack: function () {
      document.body.classList.remove("scrolled");
    },
  });

  document.querySelector(".header__button").addEventListener("click", (e) => {
    e.preventDefault();
    gsap.to(window, {
      scrollTo: { y: "footer", offsetY: 100 },
    });
  });

  //CONTACT MODAL

  var modalBtns = document.querySelectorAll('a[href="#contact"]');

  modalBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.add("open-modal");
    });
  });

  document.body.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("modal__contact") ||
      e.target.classList.contains("close")
    ) {
      document.body.classList.remove("open-modal");
    }
  });

  // RESOURCES

  var filterLinks = document.querySelectorAll(".resources__posts--filter li"),
    currentPage = 1,
    currentTag = "";

  function resetActive(tag, page) {
    document.body.classList.add("loading__posts");
    filterLinks.forEach(function (link) {
      link.classList.remove("active");
    });

    if (tag) {
      filterLinks.forEach(function (link) {
        if (link.getAttribute("data-tag") === tag) {
          link.classList.add("active");
        }
      });
    } else {
      filterLinks[0].classList.add("active");
    }
  }

  function initPagination() {
    var pageLinks = document.querySelectorAll(
        ".resources__posts--pagination li"
      ),
      prevPageLink = document.querySelector(".prev"),
      nextPageLink = document.querySelector(".next");

    pageLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        currentPage = parseInt(e.target.getAttribute("data-page"));
        loadPosts(currentTag, currentPage);
      });
    });

    prevPageLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (currentPage > 1) {
        currentPage--;
        loadPosts(currentTag, currentPage);
      }
    });

    nextPageLink.addEventListener("click", function (e) {
      e.preventDefault();
      currentPage++;
      loadPosts(currentTag, currentPage);
    });
  }

  filterLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      currentTag = e.target.getAttribute("data-tag");
      currentPage = 1;
      loadPosts(currentTag, 1);
    });
  });

  function loadPosts(tag, page) {
    resetActive(tag, page);
    gsap.to(window, 0.2, {
      scrollTo: { y: ".resources__posts" },
    });
    var xhr = new XMLHttpRequest(),
      url = tag
        ? "/blogs/resources/tagged/" + tag + "?page=" + page
        : "/blogs/resources?page=" + page;
    xhr.open("GET", url);
    xhr.onload = function () {
      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(xhr.responseText, "text/html");
      var posts = xmlDoc.getElementById("response").innerHTML;

      if (xhr.status === 200) {
        var newPosts = posts;
        document.getElementById("response").innerHTML = newPosts;
        if (posts.search("pagination") > 0) {
          initPagination();
        }
        document.body.classList.remove("loading__posts");
      }
    };
    xhr.send();
  }

  if (document.body.classList.contains("blog")) {
    initPagination();
  }
});

window.addEventListener("load", () => {
  //SWIPER
  var sliders = document.querySelectorAll(".swiper");
  if (sliders.length) {
    sliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        loop: false,
        slidesPerView: "auto",
      });

      var prev = document.querySelector(".prev"),
        next = document.querySelector(".next"),
        pagination = document.querySelectorAll(".pagination li"),
        cards = document.querySelectorAll(".features__row--right-group");

      function resetActive() {
        pagination.forEach((el) => {
          el.classList.remove("active");
        });

        cards.forEach((el) => {
          el.classList.remove("active");
        });
      }

      prev.addEventListener("click", function () {
        swiper.slidePrev();
      });
      next.addEventListener("click", function () {
        swiper.slideNext();
      });

      pagination.forEach((el, i) => {
        el.addEventListener("click", () => {
          swiper.slideTo(i);
        });
      });

      cards.forEach((el, i) => {
        el.addEventListener("click", () => {
          swiper.slideTo(i);
        });
      });

      swiper.on("slideChange", () => {
        resetActive();
        pagination[swiper.activeIndex].classList.add("active");
        cards[swiper.activeIndex].classList.add("active");
      });
    });
  }

  // MARQUEES

  gsap.utils.toArray(".marquee").forEach((el) => {
    if (document.body.classList.contains("page")) return;
    var container = el.querySelector(".marquee__container"),
      marquee = el.querySelector(".marquee__inner"),
      w = marquee.scrollWidth,
      x = Math.round(window.innerWidth / w + 1),
      dur = Math.round((w / window.innerWidth) * 15);

    if (window.innerWidth < 768) {
      var dur = Math.round((w / window.innerWidth) * 8);
    }

    for (var i = 0; i < x; i++) {
      var clone = marquee.cloneNode(true);
      container.appendChild(clone);
    }
    gsap.to(container, {
      duration: dur,
      ease: "none",
      x: "-=" + w,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x)),
      },
      repeat: -1,
    });
  });

  //PINS
  var pinReveal = document.querySelector(".process__content");

  if (pinReveal) {
    var text = pinReveal.querySelectorAll(".process__content--text h1"),
      iconVideo = pinReveal.querySelector("video");

    if (iconVideo) {
      iconVideo.play();

      setTimeout(() => {
        iconVideo.pause();
        iconVideo.currentTime = 0.01;
      }, 200);
    }

    var initialSplit = new SplitText(text[0], {
      type: "lines",
      linesClass: "line__inner",
    });

    var secondSplit = new SplitText(text[1], {
      type: "lines",
      linesClass: "line__inner",
    });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: pinReveal,
        pin: true,
        scrub: true,
        start: "top top",
        end: "+=120%",
      },
    });

    // tl.fromTo(
    //   initialSplit.lines,
    //   {
    //     scale: 0.9,
    //     opacity: 0,
    //   },
    //   {
    //     stagger: 0.1,
    //     scale: 1,
    //     opacity: 1,
    //   }
    // );
    // tl.fromTo(
    //   ".process__content--icon",
    //   {
    //     opacity: 0,
    //   },
    //   {
    //     opacity: 1,
    //   },
    //   "<"
    // );

    tl.fromTo(
      initialSplit.lines,
      {
        scale: 1,
        opacity: 1,
      },
      {
        stagger: 0.1,
        scale: 0.9,
        opacity: 0,
      }
    );

    tl.fromTo(
      secondSplit.lines,
      {
        scale: 0.9,
        opacity: 0,
      },
      {
        stagger: 0.1,
        scale: 1,
        opacity: 1,
      },
      "<60%"
    );
    tl.add(function () {
      if (!iconVideo.classList.contains("complete")) iconVideo.play();
      iconVideo.classList.add("complete");
    }, "<");
  }

  var pinContainer = document.querySelector(".process__row");
  if (pinContainer && window.innerWidth > 768) {
    var pins = pinContainer.querySelectorAll(".process__row--inner"),
      l = pins.length - 1,
      h = window.innerHeight * 1.2;
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: pinContainer,
        pin: true,
        scrub: true,
        end: () => "+=" + l * h,
      },
    });

    pins.forEach((pin, i) => {
      if (i > 0) {
        tl.to(pin, {
          y: 0,
          rotate: "0deg",
        });
        tl.to(
          pins[i - 1],
          {
            opacity: 0.5,
            scale: 0.9,
          },
          "<"
        );
      }
    });
  }

  var render = document.querySelector(".render__video video");
  if (render) {
    var tl = gsap.timeline({
      defaults: { duration: 1 },
      scrollTrigger: {
        trigger: ".render__video",
        start: "top 50%",
        // scrub: window.innerWidth > 768 ? true : false,
        // pin: window.innerWidth > 768 ? true : false,
      },
    });

    // if (window.innerWidth > 768) {
    //   tl.fromTo(
    //     render,
    //     {
    //       currentTime: 0,
    //     },
    //     {
    //       currentTime: video.duration || 1,
    //     }
    //   );
    // } else {
    //   tl.add(function () {
    //     render.play();
    //   });
    // }

    tl.add(function () {
      render.play();
    });
    tl.from(".render__video--card", 1.2, {
      scale: 0.8,
      opacity: 0,
      ease: "power4.out",
      stagger: 0.1,
      delay: 2,
    });
  }

  //ANCHORS
  var menuItems = document.querySelectorAll(".header__nav a");
  function resetMenuItems() {
    menuItems.forEach((item) => {
      item.classList.remove("active");
    });
  }

  if (document.body.classList.contains("index")) {
    menuItems.forEach((item, i) => {
      var anchor = item.hash,
        section = document.querySelector(anchor);

      ScrollTrigger.create({
        start: "top 50%",
        end: () =>
          i == 1
            ? "+=" +
              (document.querySelector("#features").clientHeight +
                document.querySelector(".features").clientHeight)
            : "bottom 50%",
        trigger: section,
        onEnter: function () {
          resetMenuItems();
          menuItems[i].classList.add("active");
        },
        onEnterBack: function () {
          resetMenuItems();
          menuItems[i].classList.add("active");
        },
      });

      menuItems[0].addEventListener("click", (e) => {
        e.preventDefault();
        gsap.to(window, {
          scrollTo: {
            y: "#how-it-works",
            offsetY:
              -document.querySelector("#how-it-works").clientHeight * 0.13,
          },
        });
      });
    });
  }
  // SCROLLTRIGGERS
  gsap.utils.toArray("h1, .animate__text").forEach((text) => {
    if (text.classList.contains("no-animate")) return;

    var split = new SplitText(text, {
      type: "lines",
      linesClass: "line__inner",
    });

    gsap.from(split.lines, 1.4, {
      yPercent: 110,
      rotationX: -90,
      stagger: 0.1,
      scale: 0.9,
      opacity: 0.5,
      ease: "power4.out",
      scrollTrigger: {
        trigger: text,
        start: "top 70%",
      },
    });
  });

  gsap.utils.toArray(".animate__scale").forEach((el) => {
    gsap.from(el, 1.2, {
      scale: 0.8,
      opacity: 0,
      ease: "power4.out",

      scrollTrigger: {
        trigger: el,
        start: "top 80%",
      },
    });
  });

  gsap.utils.toArray(".animate__section").forEach((section) => {
    gsap.to(section, {
      clipPath:
        window.innerWidth > 768
          ? "inset(0% 3% 0% 3% round 120px)"
          : "inset(0% 0% 0% 0% round 60px)",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        scrub: true,
      },
    });
  });

  gsap.utils.toArray(".rotate-shape").forEach((shape) => {
    gsap.to(shape, {
      rotate: "35deg",
      scrollTrigger: {
        trigger: shape,
        start: "top bottom",
        scrub: true,
      },
    });
  });

  // PAGE SPECIFIC
  gsap.utils.toArray(".load__once").forEach((el) => {
    gsap.from(el, 1, {
      opacity: 0,
      delay: 0.4,
      ease: "power4.out",
    });
  });

  ScrollTrigger.refresh();
  document.body.classList.remove("loading");
});
